<template>
    <div>
      <div class="tools" style="display: flex;justify-content: center;margin-bottom: 20px;">
        <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="prePage" class="mr10"> 上一页</el-button>
        <div class="page" style="margin: 10px 30px;">{{pageNum}}/{{pageTotalNum}} </div>
        <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="nextPage" class="mr10"> 下一页</el-button>
        
        <!-- <el-button :theme="'default'" style="margin-left: 50px;" type="submit" :title="'基础按钮'" @click.stop="handleDownload" class="mr10"> 下 载</el-button> -->

        <!-- <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="clock" class="mr10"> 顺时针</el-button>
        <el-button :theme="'default'" type="submit" :title="'基础按钮'" @click.stop="counterClock" class="mr10"> 逆时针</el-button> -->
      </div>
      <GuciYa-vue ref="pdf"
           :src="url"
           :page="pageNum"
           :rotate="pageRotate"
           @progress="loadedRatio = $event"
           @page-loaded="pageLoaded($event)"
           @num-pages="pageTotalNum=$event"
           @error="pdfError($event)"
           @link-clicked="page = $event">
      </GuciYa-vue>
    </div>
</template>
  <script>
// import { pdfjsLib } from 'pdfjs-dist';
  export default {
    name: 'Guciya',
    props:{
        url:{
            type:String,
            default:'http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf',
        },
    },
    data() {
      return {
        pageNum: 1,
        pageTotalNum: 1,
        pageRotate: 0,
       
        loadedRatio: 0,
        curPageNum: 0,
        scale: 2.5,
      }
    },
    mounted() {
      //this.loadPdf()
      // this.$nextTick(() => {
      //   const pdfjsLib = window['pdfjs-dist/build/pdf'];
      //   pdfjsLib.GlobalWorkerOptions.workerSrc = 'path/to/pdf.worker.js';

      //   pdfjsLib.getDocument(this.url).promise.then((pdf) => {
      //     pdf.getPage(1).then((page) => {
      //       const scale = 3;
      //       const viewport = page.getViewport({ scale });
      //       const canvas = document.createElement('canvas');
      //       const context = canvas.getContext('2d');
      //       canvas.height = viewport.height;
      //       canvas.width = viewport.width;

      //       const renderContext = {
      //         canvasContext: context,
      //         viewport: viewport,
      //       };
      //       page.render(renderContext);

      //       document.body.appendChild(canvas);
      //     });
      //   });
      // });
    },
    methods: {
      // async loadPdf() {
      //   const loadingTask = pdfjsLib.getDocument(this.url);
      //   this.pdfDoc = await loadingTask.promise;
      //   this.pageTotalNum = this.pdfDoc.numPages;
      //   this.renderPage(this.pageNum);
      // },

      // async renderPage(num) {
      //   const page = await this.pdfDoc.getPage(num);
      //   const viewport = page.getViewport({ scale: this.scale });
      //   const canvas = this.$refs.pdfCanvas;
      //   const context = canvas.getContext('2d');
      //   canvas.height = viewport.height;
      //   canvas.width = viewport.width;

      //   const renderContext = {
      //     canvasContext: context,
      //     viewport: viewport,
      //   };
      //   await page.render(renderContext).promise;
      // },

      handleDownload(){
         let ele = document.createElement('a')
         ele.setAttribute('href', this.url)
         document.body.appendChild(ele)
         ele.click()
      },

      prePage() {
            var page = this.pageNum
            page = page > 1 ? page - 1 : this.pageTotalNum
            this.pageNum = page
      },
      
      nextPage() {
        var page = this.pageNum
        page = page < this.pageTotalNum ? page + 1 : 1
        this.pageNum = page
      },
      
      clock() {
        this.pageRotate += 90
      },
     
      counterClock() {
        this.pageRotate -= 90
      },
     
      pageLoaded(e) {
        this.curPageNum = e
      },
      
      pdfError(error) {
        console.error(error)
      },
    }
  }
  </script>
  <!-- <style>
  .page img {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
  </style> -->
   


// WEBPACK FOOTER //
// src/InterviewManagement/components/Guciya-compoents.vue